<template>
  <div class="page">
    <h1>Page not found</h1>
    <p class="subtitle">The page you're looking for doesn't exist.</p>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t("seo_metadata.404.title"),
      meta: [
        { vmid: "description", name: "description", content: this.$t("seo_metadata.404.description") },
        { vmid: "robots", name: "robots", content: "noindex,nofollow" },
        { vmid: "og:title", property: "og:title", content: this.$t("seo_metadata.404.title") },
        { vmid: "og:description", property: "og:description", content: this.$t("seo_metadata.404.description") },
        { vmid: "og:type", property: "og:type", content: "website" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/theme.scss";
#app > .page {
  padding-top: 30px;
}
h1 {
  @extend %font-bold;
  text-align: center;
  font-size: 50px;
}
</style>